<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
   <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Quiz Live Dashboard
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Subject</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="course" return-object :items="course_offering_instructor_details" item-text="course" item-value="course_id" label="Subject" outlined @change="getQuizList(course);"/>
                </v-col>
             
            </v-row>
        </v-card>
         <v-card class="box" v-if="this.offeredQuizList.length > 0">
            <v-data-table :headers="headers" :items="offeredQuizList" sort-by="srno" class="elevation-1">
                <template v-slot:top>
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong>
                                Quiz Scheduling List
                            </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.meeting_link`]="{ item }">
                    <span v-if="item.meeting_link">
                        <a :href="item.meeting_link" target="_blank">{{item.meeting_link}}</a>
                    </span>
                    <span v-else>
                        <label>--</label>
                    </span>
                </template>
                <template v-slot:[`item.proceed`]="{ item }">
                     <v-btn class="button" @click="proceed(item.id)">Proceed</v-btn>
                    <!-- <v-icon class="mr-2 v-icon-size" @click="viewQuestions(item.id)" color="#0F2027">mdi-eye</v-icon> -->
                </template>
            </v-data-table>
        </v-card>
     <v-row justify="center">
            <v-dialog v-model="dialog_showstudentdata" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="dialog_showstudentdata = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Results</v-toolbar-title>
                        <v-toolbar-items>
                            <v-btn dark text @click="dialog_showstudentdata = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>

                        <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Update Extra Time For All
                        </strong>
                    </v-toolbar-title>
            </v-toolbar>
                     <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12"><br>
                     <v-text-field class="padding-bot" outlined dense v-model="extra_time_all" aria-required="true"></v-text-field>
                </v-col>
                 <v-col cols="12" xs="12" sm="2" lg="2" md="12"><br>
                     <v-btn class="button" :loading="loader" @click="updateExtraTimeForAll()">Update To All</v-btn>
                </v-col>
                     </v-row>
                        </v-card>


                     <v-card class="box">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Quiz Results
                        </strong>
                    </v-toolbar-title>
            </v-toolbar>
                     <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                        <v-data-table :headers="headers_result" :items="leraner_result_details" :search="search" class="elevation-1 ">
                    <template v-slot:[`item.update`]="{ item }">
               <v-row class="sub-row" dense>
                        <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <v-text-field class="padding-bot" outlined dense v-model="extra_time"></v-text-field>
                        </v-col>
                        <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                            <v-btn class="button" :loading="loader" @click="updateExtraTime(item.id)">Update</v-btn>
                        </v-col>
                </v-row>
                    </template>
                     <template v-slot:[`item.issubmitted`]="{ item }">
                    <v-switch v-model="item.issubmitted" color="#0F2027" @change="toggle(item)"></v-switch>
                     </template>
                        </v-data-table>
                </v-col>
                      </v-row>
                     </v-card>
                </v-card>
            </v-dialog>
     </v-row>

  </div> 
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    dialog_showstudentdata:false, 
    loader: false,
    search: "",
    snackbar_msg: "",
    snackbar: false,
    color: "",
    course_offering_instructor_details:[],
    offeredQuizList:[],
    leraner_result_details:[],
    extra_time_all:"",
    extra_time:"",
     headers: [
        { text: "Sr. No.", value: "srno", sortable: "true" },
        { text: "Title", value: "title" },
        { text: "Course", value: "course", sortable: "true" },
        { text: "Division", value: "division", sortable: "true" },
        { text: "Standard", value: "standard", sortable: "true" },
        { text: "Start Date", value: "start_date" },
        { text: "End Date", value: "end_date", sortable: "true" },
        { text: "link", value: "meeting_link", sortable: "false" },
        { text: "Proceed", value: "proceed", sortable: "false" },
        //{ text: "Questions", value: "questions", sortable: "false" },
        // { text: "Edit", value: "edit", sortable: "false" },
    ],
     headers_result: [
        { text: "Sr. No.", value: "srno", sortable: "true" },
        { text: "Title", value: "title" },
        { text: "Course", value: "course" },
        { text: "Learner", value: "learner", sortable: "true" },
        { text: "Start Date", value: "start_date", sortable: "true" },
        { text: "End Date", value: "end_date", sortable: "true" },
        { text: "Extra Time", value: "cummulative_extra_time", sortable: "true" },
        { text: "Is-Submitted", value: "issubmitted", sortable: "true" },
         { text: "Upate Extra-Time", value: "update", sortable: "false" },
     ],
  }),
  methods: {
      toggle(tg){
          const toggle = {
                    id: tg.id,
                    status: tg.issubmitted,
                };
                axios
                    .post("/LearnerQuizDashboard/toggleIssubmitted", toggle)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Updated successfully");
                            this.onLoad();
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                            this.onLoad();
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
      },
    updateExtraTime(learner){
        if(this.extra_time=="" || this.extra_time == null){
            this.showSnackbar("#b71c1c", "Please Enter Extra Time...!");
            return
        }
        const data = {
        quizschedule: localStorage.getItem("quiz_schedule_id"),
        extra_time:this.extra_time,
        quiz_learner:learner
    }
    axios
    .post("/LearnerQuizDashboard/updateExtraTime",data)
    .then((res) => {
        //  console.log(res.data)
        if (res.data.flag == "YES") {
            this.leraner_result_details=res.data.leraner_results;
            this.extra_time=""
             this.showSnackbar("#4caf50","Extra Time Updated Successfully...");
           // this.dialog_showstudentdata=true
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {}); 
    },
    updateExtraTimeForAll(){
          if(this.extra_time_all=="" || this.extra_time_all == null){
            this.showSnackbar("#b71c1c", "Please Enter Extra Time...!");
            return
        }
    const data = {
        quizschedule: localStorage.getItem("quiz_schedule_id"),
        extra_time:this.extra_time_all
    }
    axios
    .post("/LearnerQuizDashboard/updateExtraTimeForAll",data)
    .then((res) => {
        //  console.log(res.data)
        if (res.data.flag == "YES") {
            this.leraner_result_details=res.data.leraner_results;
            this.extra_time_all=""
            this.showSnackbar("#4caf50","Extra Time Updated Successfully...");
           // this.dialog_showstudentdata=true
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },

    proceed(quizschedule){
        localStorage.setItem("quiz_schedule_id",quizschedule)
        const data = {
        quizschedule: quizschedule,
    }
    axios
    .post("/LearnerQuizDashboard/proceed",data)
    .then((res) => {
        //  console.log(res.data)
        if (res.data.flag == "YES") {
            this.leraner_result_details=res.data.leraner_results;
            this.dialog_showstudentdata=true
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
    },
    getQuizList(course){
    const data = {
        course: course.course_id,
    }
    axios
    .post("/LearnerQuizDashboard/getQuizList",data)
    .then((res) => {
        //  console.log(res.data)
        if (res.data.flag == "YES") {
            this.offeredQuizList=res.data.quizSchedulings
            if(this.offeredQuizList.length <= 0){
                this.showSnackbar("#b71c1c", "No Quiz Offered For This Course...");
                return
            }
        } else {
            //   window.console.log(res.data.msg);
            this.showSnackbar("#b71c1c", "Something went wrong!");
        }
    })
    .catch((error) => {
        window.console.log(error);
    })
    .finally(() => {});
      },
    showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
    },
      onLoad() {
        axios
        .post("/QuizScheduling/scheduleQuiz")
        .then((res) => {
            //  console.log(res.data)
            if (res.data.flag == "YES") {
                this.course_offering_instructor_details = res.data.course_offering_instructor_details;
            } else {
                //   window.console.log(res.data.msg);
                this.showSnackbar("#b71c1c", "Something went wrong!");
            }
        })
        .catch((error) => {
            window.console.log(error);
        })
        .finally(() => {});
        },
  },
   mounted() {
            this.onLoad();
        },
  
};
</script>
<style scoped>

.all-pic {
        background-color: hsla(190, 99%, 30%, 1) !important;
        color: white;
    }

</style>
